<template>
  <div class="form-check" @click.prevent="value = !value">
    <input
      class="form-check-input"
      type="checkbox"
      switch
      :checked="modelValue"
      @click.stop="value = !value"
    />
    <label class="form-check-label">
      <slot name="label">
        {{ label }}
      </slot>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: Boolean,
    label: String,
    switch: Boolean,
    variant: String
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit('update:modelValue', v);
      }
    }
  }
}
</script>

<style scoped>
.form-check {
  cursor: pointer;
  padding-top: 0.15rem;
  padding-bottom: 0.15rem;
}
.form-check-label {
  cursor: pointer;
}
.form-check-input:checked {
  background-color: var(--bs-dark);
  border-color: var(--bs-dark);
}
</style>
